<template>
  <div class="comp-font-tip">
    <span v-if="this.text">{{text}}</span>
    <el-tooltip class="item" effect="dark" placement="right-start">
      <div slot="content">
        <p class="tip" v-for="item in tips">
          {{item}}
        </p>
      </div>
      <i :class="iconClass"></i>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: {
      'text': {
        type: String
      },
      'tip': {
        type: [String, Array]
      },
      'iconClass': {
        type: String,
        default: 'iconfont icon-shuoming'
      }
    },
    data () {
      return {
        tips: []
      };
    },
    created () {
      if (typeof this.tip === "string") {
        this.tips.push(this.tip);
      } else {
        this.tips = this.tip;
      }
    }
  };
</script>

<style lang="less">
  .comp-font-tip {
    display: inline !important;
    .tip {
      line-height: 30px;
    }
    .icon-shuoming {
      color: #016cdf;
    }
  }
</style>



// WEBPACK FOOTER //
// FontTip.vue?0f35a41e